<template>
  <div>
    <div>
      <div>
        <div class="form-item-label">
          <span>多选问题</span>
        </div>
        <div class="form-item-content">
          <Input size="default" v-model="attrObj.title"/>
        </div>
        <Button type="ghost" @click="addAttr">添加选项</Button>
      </div>
    </div>
    <div>
      <div v-for="(item,index) in attrObj.optionList" :key="index">
        <div>
          <div class="form-item-label">
            <span>选项{{index+1}}</span>
          </div>
          <div class="form-item-content">
            <Input size="default" v-model="item.optionContent"/>
          </div>
          <Button type="text" icon="times" @click="deleteAttr(index)"></Button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    attrObj: Object
  },
  data() {
    return {
      code: 0
    };
  },
  created() {},
  //初始化后调用
  mounted: function() {},
  methods: {
    addAttr() {
      this.attrObj.optionList.push({
        optionCode: "code" + this.code++,
        optionContent: ""
      });
    },
    deleteAttr(index) {
      this.attrObj.optionList.splice(index, 1);
    },
    //关闭
    handleClose() {
      let tabItemName = this.$parent.name;
      this.$emit("handleClose", tabItemName);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/customForm/dynamicAttr/checkbox.vue